import { animateHeroElement } from './helpers';

export const educationArchiveAnimation = () => {
	animateHeroElement(
		'.education-image-left',
		{ rotate: -10 },
		{
			rotate: 0,
			x: 43,
			y: 13,
			duration: 1.5,
			delay: 0.4,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.education-left-square',
		{ rotate: 0 },
		{
			rotate: 45,
			duration: 1,
			delay: 0.85,
			ease: 'shapeEasing',
		}
	);

	animateHeroElement(
		'.education-image-right',
		{ rotate: 0 },
		{
			rotate: -10,
			x: -34,
			y: 0,
			duration: 1.5,
			delay: 0.4,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.education-right-square',
		{},
		{
			rotate: -20,
			x: -110,
			y: 26,
			duration: 1,
			delay: 0.85,
			ease: 'shapeEasing',
		}
	);

	animateHeroElement(
		'.education-right-circle',
		{},
		{
			x: -113,
			y: 12,
			duration: 1.2,
			delay: 0.65,
			ease: 'shapeEasing',
		}
	);
};
